import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { Button, Icon } from '@sbt-web/ui';
import { LiraLazySlotReplyBox } from '@/client/components/Adv/Lira/LiraLazySlotReplyBox';
import { FormProps } from '../../types';
import { AttachmentField, ConfirmMessage, ErrorDialog, MessageField, PhoneForwarder } from './components';
import { useContactForm } from './hooks/useContactForm';
import styles from './form.module.scss';
export const Form = props => {
  const $ = _c(60);
  const {
    shouldRenderPhoneForwarder,
    buyerPhone,
    message,
    setMessage,
    replyDone,
    showErrorDialog,
    errorMessage,
    isValid,
    errors,
    recommendationSearch,
    handleSetPhoneNumber,
    handleSubmit,
    handleConfirmMessageCtaClick,
    sendAdreply,
    setCurriculum,
    setShowErrorDialog
  } = useContactForm(props);
  const {
    isMobile,
    onCloseContactForm,
    advertiserName,
    enableAttachments,
    item,
    userId
  } = props;
  let t0;
  if ($[0] !== isMobile || $[1] !== onCloseContactForm) {
    t0 = !isMobile && <Button aria-label="Chiudi" onClick={onCloseContactForm} design="text" icon={<Icon name="Close" />} classes={[styles.closeButton]} />;
    $[0] = isMobile;
    $[1] = onCloseContactForm;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== replyDone) {
    t1 = classNames(styles.container, {
      [styles.hide]: replyDone
    });
    $[3] = replyDone;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== isMobile) {
    t2 = !isMobile && <h4 className="headline-4">Contatta l'utente</h4>;
    $[5] = isMobile;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== isValid || $[8] !== setMessage) {
    t3 = newMessage => {
      isValid(newMessage);
      setMessage(newMessage);
    };
    $[7] = isValid;
    $[8] = setMessage;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== errorMessage || $[11] !== message || $[12] !== t3) {
    t4 = <MessageField message={message} onChangeMessage={t3} errorMessage={errorMessage} />;
    $[10] = errorMessage;
    $[11] = message;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== buyerPhone || $[15] !== handleSetPhoneNumber || $[16] !== isMobile || $[17] !== shouldRenderPhoneForwarder) {
    t5 = shouldRenderPhoneForwarder && <PhoneForwarder phone={buyerPhone} onSetPhoneNumber={handleSetPhoneNumber} isMobile={isMobile} />;
    $[14] = buyerPhone;
    $[15] = handleSetPhoneNumber;
    $[16] = isMobile;
    $[17] = shouldRenderPhoneForwarder;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== enableAttachments || $[20] !== errors || $[21] !== setCurriculum) {
    t6 = enableAttachments && <AttachmentField name="curriculum" placeholder="Carica file" onChange={file => setCurriculum(file)} errors={errors} />;
    $[19] = enableAttachments;
    $[20] = errors;
    $[21] = setCurriculum;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Button type="submit" classes={[styles.submitButton]}>Invia</Button>;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== handleSubmit || $[25] !== t4 || $[26] !== t5 || $[27] !== t6) {
    t8 = <form method="post" name="adreply_form" onSubmit={handleSubmit} className={styles.form}>{t4}{t5}{t6}{t7}</form>;
    $[24] = handleSubmit;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  let t9;
  if ($[29] !== t1 || $[30] !== t2 || $[31] !== t8) {
    t9 = <div id="adreply_form_container" className={t1}>{t2}{t8}</div>;
    $[29] = t1;
    $[30] = t2;
    $[31] = t8;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] !== advertiserName || $[34] !== handleConfirmMessageCtaClick || $[35] !== item || $[36] !== recommendationSearch || $[37] !== replyDone) {
    t10 = replyDone && <ConfirmMessage advertiserName={advertiserName} isVisible={replyDone} categoryId={item.category.id} onClick={handleConfirmMessageCtaClick} recommendedSearch={!!recommendationSearch} />;
    $[33] = advertiserName;
    $[34] = handleConfirmMessageCtaClick;
    $[35] = item;
    $[36] = recommendationSearch;
    $[37] = replyDone;
    $[38] = t10;
  } else {
    t10 = $[38];
  }
  let t11;
  if ($[39] !== replyDone) {
    t11 = replyDone ? <LiraLazySlotReplyBox /> : null;
    $[39] = replyDone;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  let t12;
  if ($[41] !== t0 || $[42] !== t10 || $[43] !== t11 || $[44] !== t9) {
    t12 = <div className={styles.formWrapper}>{t0}{t9}{t10}{t11}</div>;
    $[41] = t0;
    $[42] = t10;
    $[43] = t11;
    $[44] = t9;
    $[45] = t12;
  } else {
    t12 = $[45];
  }
  let t13;
  if ($[46] !== setShowErrorDialog) {
    t13 = () => setShowErrorDialog(false);
    $[46] = setShowErrorDialog;
    $[47] = t13;
  } else {
    t13 = $[47];
  }
  let t14;
  if ($[48] !== sendAdreply || $[49] !== setShowErrorDialog || $[50] !== userId) {
    t14 = () => {
      setShowErrorDialog(false);
      sendAdreply(userId);
    };
    $[48] = sendAdreply;
    $[49] = setShowErrorDialog;
    $[50] = userId;
    $[51] = t14;
  } else {
    t14 = $[51];
  }
  let t15;
  if ($[52] !== errors || $[53] !== showErrorDialog || $[54] !== t13 || $[55] !== t14) {
    t15 = <ErrorDialog isOpened={showErrorDialog} onClose={t13} errors={errors} onRetry={t14} />;
    $[52] = errors;
    $[53] = showErrorDialog;
    $[54] = t13;
    $[55] = t14;
    $[56] = t15;
  } else {
    t15 = $[56];
  }
  let t16;
  if ($[57] !== t12 || $[58] !== t15) {
    t16 = <>{t12}{t15}</>;
    $[57] = t12;
    $[58] = t15;
    $[59] = t16;
  } else {
    t16 = $[59];
  }
  return t16;
};